/**
 * Catálogo de métricas, carregado de `GET monitoramento/metricas`.
 *
 * O catálogo mora no servidor (App\Support\Metrics\MetricCatalog) e é a mesma
 * fonte que valida as regras de alerta e formata o e-mail. Buscá-lo em vez de
 * manter uma cópia aqui é o que garante que rótulo, unidade e whitelist nunca
 * divirjam entre a tela e o alerta.
 *
 * O módulo é um singleton: a primeira chamada busca, as demais reaproveitam.
 */

let CATALOGO = [];
let GRUPOS = [];
let promessa = null;

export function carregarCatalogo(http) {
    if (!promessa) {
        promessa = http.get('monitoramento/metricas')
            .then(({ data }) => {
                CATALOGO = data.metricas || [];
                GRUPOS = data.grupos || [];
                return data;
            })
            .catch((e) => {
                // Deixa tentar de novo na próxima montagem em vez de congelar
                // a tela num catálogo vazio.
                promessa = null;
                throw e;
            });
    }

    return promessa;
}

export function catalogo() {
    return CATALOGO;
}

export function grupos() {
    return GRUPOS;
}

export function metrica(coluna) {
    return CATALOGO.find(m => m.coluna === coluna)
        || { coluna, label: coluna, unidade: '', direcao: 'maior_pior' };
}

export function formatarValor(coluna, valor) {
    if (valor === null || valor === undefined) return '—';

    const { unidade } = metrica(coluna);
    const v = Number(valor);
    const n = Number.isInteger(v) || Math.abs(v) >= 100 ? v.toFixed(0) : v.toFixed(1);

    if (!unidade) return n;
    return unidade === '%' ? `${n}%` : `${n} ${unidade}`;
}
